import React from 'react';

import { Box, Typography, IconButton, Divider } from '@mui/material';
import clsx from 'clsx';
import Hidden from 'components/Hidden';
import PropTypes from 'prop-types';

import styles from './formComponents.module.css';

import { ReactComponent as CloseIcon } from 'asset/IconsPack/hx_x-close.svg';

function FormHeader({
    title = '',
    subtitle = '',
    handleClose = () => {},
    children,
    titleClassName = '',
    subtitleClassName = '',
    hideDivider = false,
    wrapperStyle = '',
}) {
    return (
        <>
            <Box className={clsx(styles.commonFormHeader, wrapperStyle)}>
                <Box className={styles.mobileFormHeading}>
                    <Hidden smUp>
                        <IconButton onClick={handleClose} className={styles.modalCloseBtnMobile}>
                            <CloseIcon className={styles.modalCloseIcon} />
                        </IconButton>
                    </Hidden>
                    <Box>
                        <Typography className={clsx(titleClassName, styles.commonFormHeading)}>
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography
                                className={clsx(subtitleClassName, styles.commonFormSubHeading)}
                            >
                                {subtitle}
                            </Typography>
                        )}
                        {children}
                    </Box>
                </Box>

                <Hidden smDown>
                    <IconButton onClick={handleClose} className={styles.modalCloseBtn}>
                        <CloseIcon className={styles.modalCloseIcon} />
                    </IconButton>
                </Hidden>
            </Box>
            {!hideDivider && <Divider className={styles.divider} />}
        </>
    );
}

FormHeader.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.string,
    handleClose: PropTypes.func,
    children: PropTypes.node,
    titleClassName: PropTypes.string,
    subtitleClassName: PropTypes.string,
    hideDivider: PropTypes.bool,
    wrapperStyle: PropTypes.string,
};

export default FormHeader;
